import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Spin, message } from "antd";
import Bridge from "./utils/Bridge";

export default class UploadPDFForGeneticConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pdf_document: "",
      is_document_present: false,
      pdf_document_url: "",
    };
  }
  componentDidMount() {
    this.check_genetic_confirmation_document();
  }
  // check if genetic confirmation document is present or not
  check_genetic_confirmation_document = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    this.setState({ loading: true });
    Bridge.genetic_confirmation_document
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          if (response.data.length > 0) {
            this.setState({ is_document_present: true });
          } else {
            this.setState({ is_document_present: false });
          }
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  // upload pdf
  upload_pdf = () => {
    if (!this.state.pdf_document) {
      message.warning("Please select pdf file.");
      return;
    }
    if (
      this.state.pdf_document &&
      this.state.pdf_document.type != "application/pdf"
    ) {
      message.warning("Please select valid file.");
      return;
    }
    var formData = new FormData();
    formData.append("files", this.state.pdf_document);
    formData.append("eals_id", localStorage.getItem("ap_eals_id"));
    this.setState({ loading: true });
    Bridge.genetic_confirmation_document
      .upload(formData)
      .then((response) => {
        if (response.status == "1") {
          message.success(response.message);
          this.setState(
            {
              pdf_document: "",
              loading: false,
            },
            () => this.check_genetic_confirmation_document()
          );
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  // view pdf
  view_pdf = () => {
    this.setState({ loading: true });
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.genetic_confirmation_document
      .view_pdf(params)
      .then((response) => {
        if (response.status == "1") {
          window.open(response.url, "_blank");
          this.setState({
            pdf_document_url: response.url,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  // remove pdf
  remove_pdf = () => {
    this.setState({ loading: true });
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.genetic_confirmation_document
      .remove_pdf(params)
      .then((response) => {
        if (response.status == "1") {
          message.success(response.message);
          this.setState(
            {
              loading: false,
            },
            () => this.check_genetic_confirmation_document()
          );
        } else {
          message.warning(response.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChangePdf = (e) => {
    this.setState({
      pdf_document: e.target.files[0],
    });
  };
  render() {
    const inputPDFStyles = {
      padding: "9px 9px",
    };
    const removeButtonStyles = {
      marginLeft: 15,
    };
    return (
      <div>
        <Header />
        <div
          className="main-content demographics-wrapper"
          style={{ paddingTop: 40 }}
        >
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-6">
                <a href="/dashboard" className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Dashboard
                </a>
                <Spin spinning={this.state.loading}>
                  <div className="change-password-form">
                    <h3 className="pb-0 mb-0">
                      Upload PDF For Genetic Confirmation
                    </h3>
                    <hr />
                    {this.state.is_document_present == false ? (
                      <>
                        <div className="form-group pt-4">
                          <label>
                            <box-icon
                              type="solid"
                              name="file-pdf"
                              color="#9e9e9e"
                              size="23px"
                              style={{ marginTop: 0, marginRight: 12 }}
                            ></box-icon>{" "}
                            Select PDF
                          </label>
                          <input
                            type="file"
                            onChange={this.onChangePdf}
                            accept={".pdf"}
                            style={inputPDFStyles}
                          />
                        </div>
                        <button
                          className="submit-button"
                          onClick={() => this.upload_pdf()}
                        >
                          Upload{" "}
                          <box-icon
                            name="chevron-right"
                            color="#fff"
                            style={{ position: "relative", top: 1 }}
                          ></box-icon>
                        </button>
                      </>
                    ) : (
                      <div className="d-flex">
                        <button
                          className="submit-button"
                          onClick={() => this.view_pdf()}
                        >
                          View PDF{" "}
                          <box-icon
                            name="chevron-right"
                            color="#fff"
                            style={{ position: "relative", top: 1 }}
                          ></box-icon>
                        </button>
                        <button
                          className="submit-button"
                          onClick={() => this.remove_pdf()}
                          style={removeButtonStyles}
                        >
                          Remove PDF &nbsp;
                          <box-icon
                            name="trash"
                            color="#fff"
                            size={"18px"}
                            style={{ position: "relative", top: 3 }}
                          ></box-icon>
                        </button>
                      </div>
                    )}
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
